import React, { useState } from 'react';
import styled from 'styled-components';
import { FaFolder } from 'react-icons/fa';
import { FiEdit2, FiTrash2 } from 'react-icons/fi';
import ChipButton from './ChipButton';
import { assetTheme as t } from './assetTheme';

const Card = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  background: ${({ $isDragOver }) => $isDragOver ? t.teal100 : t.surface};
  border: 1px ${({ $isDragOver }) => $isDragOver ? 'dashed' : 'solid'} ${({ $isDragOver }) => $isDragOver ? t.tealBrand : t.border};
  border-radius: 12px;
  padding: 14px 16px;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  color: ${t.text};
  transition: border-color .12s, box-shadow .12s;

  &:hover {
    border-color: ${t.tealBrand};
    box-shadow: 0 4px 14px rgba(0,19,35,.08);
  }
`

const Name = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const QuickActions = styled.div`
  position: absolute;
  top: -12px;
  right: 10px;
  display: none;
  gap: 4px;

  ${Card}:hover & {
    display: flex;
  }
`

export default ({
  folder,
  onOpen,
  onRename,
  onDelete,
  onDropFile
}) => {
  const [isDragOver, setIsDragOver] = useState(false)

  return (
    <Card
      $isDragOver={isDragOver}
      onClick={() => onOpen(folder.path)}
      onDragOver={(e) => { e.preventDefault(); }}
      onDragEnter={(e) => { e.preventDefault(); setIsDragOver(true); }}
      onDragLeave={() => setIsDragOver(false)}
      onDrop={(e) => {
        e.preventDefault();
        setIsDragOver(false);
        onDropFile(e, folder.path);
      }}
    >
      <FaFolder style={{ color: t.yellow, fontSize: '18px', flex: 'none' }} />
      <Name>{folder.name}</Name>
      <QuickActions>
        <ChipButton $variant='light' title='Rename folder' onClick={(e) => { e.stopPropagation(); onRename(folder); }}>
          <FiEdit2 />
        </ChipButton>
        <ChipButton $variant='light' title='Delete folder' onClick={(e) => { e.stopPropagation(); onDelete(folder); }}>
          <FiTrash2 />
        </ChipButton>
      </QuickActions>
    </Card>
  )
}
